import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const otherRoute = [];

const routeContext = require.context('./modules', true, /\.js$/);

routeContext.keys().forEach(item => {
    const routeModule = routeContext(item);
    if (Object.keys(routeModule).length > 0) {
        otherRoute.push(...(routeModule.default || routeModule));
    }
});

/**
 * 需要缓存的路由在meta中添加 keepAlive: true
 * 需要登录的页面在meta中添加 needLogin: true
 * 需要显示footer在meta中添加 showFooter: true
 */
const routes = [{
        path: '/',
        name: 'layout',
        component: () => import('../layout/index.vue'),
        children: [{
                path: '',
                redirect: '/home'
            }, {
                path: '/home',
                name: '首页',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../views/home.vue')
            }, {
                path: '/history',
                name: '发展历程',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../views/history.vue')
            },
            // modules 其他路由
            ...otherRoute
        ]
    },
    // 错误路由
    {
        path: '/404',
        name: 'error',
        meta: {
            keepAlive: true
        },
        component: () => import('../layout/error.vue')
    }, {
        path: '*',
        redirect: '/404'
    }
];

const router = new VueRouter({
    routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
    // if (to.meta.needLogin && !store.state.user.token && from.fullPath !== '/passport/login') {
    //     Message({
    //         message: '用户尚未登录，请登录',
    //         type: 'error',
    //         duration: 3 * 1000,
    //         showClose: true
    //     });
    //     next({
    //         path: '/passport/login'
    //     });
    // }
    document.title = to.name;
    next();
});

export default router;
